import { useMemo } from "react";
import "./SidebarLocation.scss";
import IconContainer from "./icons/IconContainer";
import LocationIcon from "./icons/LocationIcon";

export default function SidebarLocation({ location, onLocationSelected }) {
  const handleLocationSelected = (location) => {
    if (onLocationSelected && typeof onLocationSelected === "function") {
      onLocationSelected(location);
    }
  };

  const source = useMemo(() => {
    return (
      <button
        className="button"
        onClick={() => {
          handleLocationSelected(location);
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <div>
            <IconContainer color={location.properties.location.category?.color}>
              <LocationIcon category={location.properties.location.category} />
            </IconContainer>
          </div>
          <div>
            <p className="location-name">{location.properties.location.name}</p>
            <p className="location-address">
              {location.properties.location.address}
            </p>
          </div>
        </div>
      </button>
    );
  }, [location]);

  return source;
}
